module.exports = __webpack_public_path__ + "static/media/PP4-HD.30e93661.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Paper4/PP4-HD.png
// module id = 273
// module chunks = 0